import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/CyclistWeatherDashboard'; // Ihre Startseite
import SunnyScorePage from './components/SunnyScorePage';
import InfoPage from './components/InfoPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/score" element={<SunnyScorePage />} />
        <Route path="/info" element={<InfoPage />} />
      </Routes>
    </Router>
  );
}

export default App;